<template>
  <div class="separator__container row center">
    <div v-if="type === 'contact'" class="separator row">
      <h3>{{ t('separator_h_01') }}</h3>

      <div class="link__container row">
        <a href="mailto:info@arcticreply.com">
          <i class="fa-solid fa-paper-plane"></i>
          <span>{{ t('separator_cta_01') }}</span>
        </a>
      </div>
    </div>

    <div v-else-if="type === 'question'" class="separator row">
      <h3>{{ t('separator_h_02') }}</h3>

      <div class="link__container row">
        <a href="mailto:info@arcticreply.com">
          <i class="fa-solid fa-paper-plane"></i>
          <span>{{ t('separator_cta_02') }}</span>
        </a>
      </div>
    </div>

    <div v-else-if="type === 'try'" class="separator row">
      <h3>{{ t('separator_h_03') }}</h3>

      <div class="link__container row">
        <a href="#generator">
          <i class="fa-solid fa-vial"></i>
          <span>{{ t('separator_cta_03') }}</span>
        </a>
      </div>
    </div>

    <div v-else-if="type === 'ready'" class="separator row">
      <h3>{{ t('separator_h_04') }}</h3>

      <div class="link__container row">
        <a
          :href="`https://app.arcticreply.com/auth/register?language=${$store.state.language}&campaign=${$store.state.campaign}`"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i class="fa-solid fa-user-plus"></i>
          <span>{{ t('separator_cta_04') }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Separator',
  props: {
    type: { type: String, default: 'contact' },
  },
}
</script>

<style lang="scss" scoped>
.separator__container {
  width: 100%;
  margin: 150px auto 0 auto;

  .separator {
    padding: 30px 50px;
    border-radius: 25px;
    margin: 0 auto;
    color: var(--base);
    width: 600px;
    max-width: calc(95% - 100px);
    background-color: var(--dark-10);
    align-items: center;
    justify-content: space-between;

    @media (max-width: 750px) {
      flex-direction: column;
    }

    h3 {
      font-size: 1.5rem;
      font-weight: normal;
      width: 55%;
      margin: 0;

      @media (max-width: 750px) {
        width: 100%;
        text-align: center;
        margin-bottom: 20px;
      }
    }

    .link__container {
      width: 40%;
      align-items: center;
      justify-content: flex-end;

      @media (max-width: 750px) {
        width: 100%;
        justify-content: center;
      }

      a {
        background-color: var(--base);
        padding: 10px 25px;
        border-radius: 25px;
        font-size: 1.1rem;

        i {
          margin-right: 10px;
        }

        &:hover,
        &:active {
          transform: scale(0.98);
        }
      }
    }
  }
}
</style>
